/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function objectWithout(object, keysToRemove) {
    return keysToRemove.reduce(function (reducedObject, key) {
        delete reducedObject[key];
        return reducedObject;
    }, tslib_1.__assign({}, object));
}
exports.objectWithout = objectWithout;